import { PricingTable } from "@clerk/clerk-react";
import "./ClerkBillingPage.css";
import { SidebarInset, SidebarProvider } from "../ui/sidebar";
import { AppSidebar } from "../AppSidebar";
import { SiteHeader } from "../SiteHeader";

const ClerkBillingPage = () => {
  return (
       <SidebarProvider>
        <AppSidebar variant="inset" />
        <SidebarInset className="flex flex-col min-h-screen">
          <SiteHeader className="sticky top-0 z-10" />
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex flex-col items-center justify-start p-4">
      <div className="w-full max-w-7xl mx-auto">
        {/* Header & Description */}
        <div className="text-center space-y-4 mb-8">
          <h1 className="text-3xl font-light tracking-tight text-slate-900 dark:text-white bg-gradient-to-br from-slate-900 to-slate-600 dark:from-white dark:to-slate-300 bg-clip-text">
            Pricing Plans
          </h1>
          <p className="text-lg text-slate-600 dark:text-slate-400 max-w-3xl mx-auto leading-relaxed my-2">
            Choose the plan that fits your needs. All plans include core
            features with flexible scaling options.
          </p>
        </div>

        {/* Pricing Table */}
        <div className="flex justify-center">
          <PricingTable
            appearance={{
              variables: {
                colorPrimary: "#6366f1",
                fontFamily:
                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
              },
              elements: {
                // Main card styling
                card: "pricing-card-custom",

                // Plan name
                planName:
                  "text-2xl font-bold text-slate-900 dark:text-white mb-4 relative z-5",

                // Price styling
                price:
                  "text-4xl font-extrabold text-slate-900 dark:text-white mb-1 relative z-5",

                // Features list
                featureList:
                  "space-y-3 my-6 text-slate-700 dark:text-slate-300 relative z-5",

                // CTA button
                ctaButton:
                  "w-full py-4 px-8 rounded-xl font-semibold transition-all duration-200 bg-indigo-600 hover:bg-indigo-700 text-white shadow-lg hover:shadow-xl transform hover:-translate-y-1 relative z-5",
              },
            }}
            ctaPosition="bottom"
            collapseFeatures={false}
            forOrganizations={false}
            newSubscriptionRedirectUrl="billing"
            fallback={
              <div className="flex items-center justify-center py-16">
                <div className="text-slate-900 dark:text-white text-xl font-medium">
                  Loading plans...
                </div>
              </div>
            }
          />
        </div>
      </div>
    </div>
     </SidebarInset>
      </SidebarProvider>
  );
};

export default ClerkBillingPage;
